import { render, staticRenderFns } from "./rewardInviteHelpEdit.vue?vue&type=template&id=58aaad46&scoped=true&"
import script from "./rewardInviteHelpEdit.vue?vue&type=script&lang=js&"
export * from "./rewardInviteHelpEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aaad46",
  null
  
)

export default component.exports